module.exports = __webpack_public_path__ + "static/media/interactive.f433e829.svg";